import { render } from "./Index.vue?vue&type=template&id=01a7d2a0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=01a7d2a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01a7d2a0"

export default script